import React from "react";
import PropTypes from "prop-types";
import config from "../../res/config.json";
import { cssStyles } from "./pdfContractStyles";
import {
  roundTotalMonthlyFeeByCountry,
  formatNumber,
} from "../../logic/GeneralFunctions";
const emptyLabel = " ";
let objektNr = 0;

export default class CreateContract extends React.Component {
  static propTypes = {
    formInformation: PropTypes.object,
    productsValues: PropTypes.object,
    customerInformation: PropTypes.object,
    labels: PropTypes.object,
    accessories: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    params: PropTypes.object,
    switchFormState: PropTypes.func,
    products: PropTypes.array,
    nrOfAccessories: PropTypes.number,
  };

  state = {
    headerImgSrc: "",
  };

  splitPNCNumAndName(item) {
    const regex = /^(\d+)\s*(.*)/;
    const match = item.match(regex);
    if (match) {
      return { id: match[1], name: match[2].trim() };
    } else {
      return { id: null, name: item.trim() };
    }
  }

  generateProducts = (key, objektNr) => {
    const isAccessory =
      this.props.productsValues[key].name === "Tillbehör" ||
      this.props.productsValues[key].name === "Tilbehør";
    const productName = this.splitPNCNumAndName(
      this.props.productsValues[key].name || ""
    ).name;
    return (
      <>
        <tr className="contract-table-header">
          <th colSpan="4" className="contract-small-margin-top">
            {this.props.params.lang === "fr"
              ? "MATÉRIEL N°" + objektNr
              : "Objekt #" + objektNr}
          </th>
        </tr>
        <tr>
          <td colSpan={4}>
            <table
              className={`contract-table contract-product-table-${this.props.params.lang.toLowerCase()}`}
            >
              <tr>
                <td className="contract-td contract-product-cell">
                  <p className="contract-helper-text contract-product-label">
                    {this.props.labels.object_type}
                  </p>
                  <p className="contract-product-value">{productName}</p>
                </td>
                <td className="contract-td contract-product-cell contract-quater-space">
                  <p className="contract-helper-text contract-product-label">
                    {this.props.labels.serial_numbers}
                  </p>
                  <p className="contract-product-value">
                    {this.props.productsValues[key].serial.length > 0
                      ? this.props.productsValues[key].serial[0]
                      : ""}
                  </p>
                </td>
                <td className="contract-td contract-product-cell">
                  <p className="contract-helper-text contract-product-label">
                    {this.props.labels.number_of_months}
                  </p>
                  <p className="contract-product-value">
                    {this.props.formInformation.contractLength}
                  </p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        {this.props.params.lang === "de" && (
          <>
            <tr className="contract-table-header">
              <th colSpan={2} className="contract-half-space">
                <p className="contract-small-margin-top">
                  {this.props.labels.lessor_obligations}
                </p>
              </th>
              <th
                colSpan={2}
                className="contract-half-space contract-small-margin-top"
              >
                <p className="contract-small-margin-top">
                  {this.props.labels.insurance_responsability}
                </p>
              </th>
            </tr>
            <tr>
              <td colSpan={2} className="contract-td contract-half-space">
                <p className="contract-helper-text">
                  {this.props.labels.service}
                </p>
                <p className="contract-service-value contract-service-value-after-label">
                  {this.props.labels.positive_answer}
                </p>
              </td>
              <td colSpan={2} className="contract-td contract-half-space">
                <p className="contract-service-value">
                  {this.props.labels.lessor}
                </p>
              </td>
            </tr>
          </>
        )}

        {this.props.params.lang === "fr" && (
          <>
            <tr>
              <td>
                <p></p>
              </td>
            </tr>
            <tr className="contract-table-header">
              <th
                colSpan="4"
                className="contract-small-margin-top contract-service-header"
              >
                OBLIGATIONS DU BAILLEUR etc.
              </th>
            </tr>
            <tr>
              <td colSpan={4} className="contract-td">
                <div
                  className="contract-service-row"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span>Husqvarna Care</span>
                  <div className="contract-checkbox-checked pdf-checkbox-gap"></div>
                  <span>Oui</span>
                  <div className="contract-checkbox-empty pdf-checkbox-gap"></div>
                  <span>Non</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <p></p>
              </td>
            </tr>
            <tr className="contract-table-header">
              <th
                colSpan="4"
                className="contract-small-margin-top contract-service-header"
              >
                ASSURANCE DEVANT ÊTRE SOUSCRITE PAR
              </th>
            </tr>
            <tr>
              <td colSpan={4} className="contract-td">
                <div
                  className="contract-service-row"
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div className="contract-checkbox-checked"></div>
                    <span>Le Bailleur</span>
                    <div className="contract-checkbox-empty pdf-checkbox-gap"></div>
                    <span>Le Locataire</span>
                  </div>
                  <p className="contract-helper-text contract-annex-note">
                    Conditions particulières jointes en annexe
                  </p>
                </div>
              </td>
            </tr>
          </>
        )}

        {this.props.params.lang === "de" && (
          <>
            <tr>
              <td>
                <p></p>
              </td>
            </tr>
            <tr className="contract-table-header">
              <th
                colSpan="4"
                className="contract-small-margin-top contract-service-header"
              >
                ZUSATSSERVICES DER VERMIETERIN etc
              </th>
            </tr>
            <tr>
              <td colSpan={4} className="contract-td">
                <div
                  className="contract-service-row"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span>Husqvarna Care</span>
                  <div className="contract-checkbox-checked pdf-checkbox-gap"></div>
                  <span>Ja</span>
                  <div className="contract-checkbox-empty pdf-checkbox-gap"></div>
                  <span>Nein</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <p></p>
              </td>
            </tr>
            <tr className="contract-table-header">
              <th
                colSpan="4"
                className="contract-small-margin-top contract-service-header"
              >
                BEGINN DER DIENSTLEISTUNGEN WÄHREND DER WIDERRUFSFRIST
              </th>
            </tr>
            <tr>
              <td colSpan={4} className="contract-td">
                <div
                  className="contract-service-row"
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div className="contract-checkbox-checked"></div>
                    <span>Ja</span>
                    <div className="contract-checkbox-empty pdf-checkbox-gap"></div>
                    <span>Nein</span>
                  </div>
                  <p style={{ margin: "0 0 0 20px" }}>
                    Wenn ja, so haben Sie uns bei Widerruf einen angemessenen
                    Betrag zu zahlen, der dem Anteil der bis zu dem Zeitpunkt,
                    zu dem Sie uns von der Ausübung des Widerrufsrechts
                    hinsichtlich dieses Vertrags unterrichten, bereits
                    erbrachten Dienstleistungen im Vergleich zum Gesamtumfang
                    der im Vertrag vorgesehenen Dienstleistungen entspricht.
                  </p>
                </div>
              </td>
            </tr>
          </>
        )}
        {(this.props.params.lang.toLowerCase() === "se" ||
          this.props.params.lang.toLowerCase() === "no" ||
          this.props.params.lang.toLowerCase() === "dk") && (
          <>
            <tr className="contract-table-header">
              <th colSpan={2} className="contract-section-th">
                {this.props.labels.lessor_obligations}
              </th>
              <td colSpan={2} className="contract-td-noborder"></td>
            </tr>
            <tr>
              <td colSpan={4} className="contract-td-noborder">
                <table className="contract-care-table">
                  <tr>
                    <td className="contract-td contract-care-label">
                      <p className="contract-p-margin">
                        {this.props.labels.husqvarna_care_label}
                      </p>
                    </td>
                    <td className="contract-td contract-checkbox-cell">
                      <p className="contract-p-margin">
                        <span className="pdf-checkbox">
                          {isAccessory ? "" : "X"}
                        </span>{" "}
                        {this.props.labels.positive_answer}
                        <span className="pdf-checkbox pdf-checkbox-gap">
                          {isAccessory ? "X" : ""}
                        </span>{" "}
                        {this.props.labels.negative_answer}
                      </p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr className="contract-table-header">
              <th colSpan="4" className="contract-section-th">
                {this.props.labels.insurance_responsability}
              </th>
            </tr>
            <tr>
              <td colSpan={1} className="contract-td">
                <p className="contract-insurance-p">
                  <span className="pdf-checkbox">{isAccessory ? "" : "X"}</span>{" "}
                  {this.props.labels.lessor}
                  <span className="pdf-checkbox pdf-checkbox-gap">
                    {isAccessory ? "X" : ""}
                  </span>{" "}
                  {this.props.labels.lessee}
                </p>
              </td>
              <td colSpan={3} className="contract-td">
                <p className="contract-helper-text">
                  {this.props.labels.special_terms_appendix}
                </p>
                <p className="contract-p-margin"> </p>
              </td>
            </tr>
          </>
        )}
        <tr>
          <td colSpan={4}>
            <p className="contract-section-spacer"></p>
          </td>
        </tr>
      </>
    );
  };

  generateAccessories = (key, accessoryId, objektNr) => {
    return (
      <>
        <tr className="contract-table-header">
          <th colSpan="4" className="contract-small-margin-top">
            {"Objekt #" + objektNr}
          </th>
        </tr>
        <tr>
          <td colSpan={4}>
            <table className="contract-table">
              <tr>
                <td className="contract-td contract-product-cell">
                  <p className="contract-helper-text contract-product-label">
                    {this.props.labels.object_type}
                  </p>
                  <p className="contract-product-value">
                    {this.props.productsValues[key].accessory[accessoryId]}
                  </p>
                </td>
                <td className="contract-td contract-product-cell contract-quater-space">
                  <p className="contract-helper-text contract-product-label">
                    {this.props.labels.serial_numbers}
                  </p>
                  <p>
                    {this.props.productsValues[key].serial.length > 1
                      ? this.props.productsValues[key].serial[1]
                      : ""}
                  </p>
                </td>
                <td className="contract-td contract-product-cell">
                  <p className="contract-helper-text contract-product-label">
                    {this.props.labels.number_of_months}
                  </p>
                  <p className="contract-product-value">
                    {this.props.formInformation.contractLength}
                  </p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr className="contract-table-header">
          <th colSpan={2} className="contract-half-space">
            <p className="contract-small-margin-top">
              {this.props.labels.lessor_obligations}
            </p>
          </th>
          <th
            colSpan={2}
            className="contract-half-space contract-small-margin-top"
          >
            <p className="contract-small-margin-top">
              {this.props.labels.insurance_responsability}
            </p>
          </th>
        </tr>
        <tr>
          <td colSpan={2} className="contract-td contract-half-space">
            <p className="contract-helper-text">{this.props.labels.service}</p>
            <p className="contract-service-value contract-service-value-after-label">
              {this.props.labels.if_applicable}
            </p>
          </td>
          <td colSpan={2} className="contract-td contract-half-space">
            <p className="contract-service-value">{this.props.labels.lessor}</p>
          </td>
        </tr>
        <tr>
          <td>
            <p></p>
          </td>
        </tr>
      </>
    );
  };

  generateDynamicPages = (lang) => {
    const maxTablesPerPageMap = {
      de: 2,
      fr: 4,
      se: 4,
      no: 4,
      dk: 4,
    };
    const MAX_TABLES_PER_PAGE = maxTablesPerPageMap[lang] || 3;

    const productSections = [];
    objektNr = 0;

    Object.keys(this.props.productsValues).forEach((id) => {
      if (this.props.productsValues[id].name !== null) {
        objektNr = objektNr + 1;
        productSections.push(this.generateProducts(id, objektNr));
      }
    });

    if (this.props.nrOfAccessories > 0) {
      Object.keys(this.props.productsValues).forEach((id) => {
        for (const accessoryId in this.props.productsValues[id].accessory) {
          const accessory =
            this.props.productsValues[id].accessory[accessoryId];
          if (accessory !== null) {
            objektNr = objektNr + 1;
            productSections.push(
              this.generateAccessories(id, accessoryId, objektNr)
            );
          }
        }
      });
    }

    const pages = [];
    for (let i = 0; i < productSections.length; i += MAX_TABLES_PER_PAGE) {
      pages.push(productSections.slice(i, i + MAX_TABLES_PER_PAGE));
    }

    return pages.map((pageProductSections, pageIndex) => (
      <React.Fragment key={`product-page-${pageIndex}`}>
        {pageIndex > 0 && <div className="page-break"></div>}
        <div className="contract-header">
          <img
            src={
              config.ROOT +
              `getimage?company=hcs&country=images&type=logo_flat.png`
            }
            alt=""
            width="40%"
          ></img>
          <div>
            <h4 className="contract-table-header">
              {this.props.labels.contract_agreement.toUpperCase()}
            </h4>
            <table className="contract-table">
              <tr>
                <td className="contract-td">
                  <p>{this.props.labels.contract_number}</p>
                </td>
                <td className="contract-td contract-min-width">
                  <p>
                    {lang === "fr" || lang === "de"
                      ? this.props.formInformation.contractNumber
                      : ""}
                  </p>
                </td>
              </tr>
              <tr>
                <td className="contract-td">
                  <p>{this.props.labels.dealer_ref_nr}</p>
                </td>
                <td className="contract-td contract-min-width">
                  <p>{this.props.customerInformation.customerNumber}</p>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div>
          <table className="contract-table margin-top-large">
            {pageIndex === 0 && (
              <tr className="contract-table-header">
                <th>{this.props.labels.label_main_products.toUpperCase()}</th>
              </tr>
            )}
            {pageProductSections}
          </table>
        </div>
      </React.Fragment>
    ));
  };

  render() {
    const lang = this.props.params.lang.toLowerCase();
    return (
      <div className="wrapper">
        <style>{cssStyles}</style>
        <div id="contractPdf" className="contract-body">
          <div className="contract-header">
            <img
              src={
                config.ROOT +
                `getimage?company=hcs&country=images&type=logo_flat.png`
              }
              alt=""
              width="40%"
            ></img>
            <div>
              <h4 className="contract-table-header">
                {this.props.labels.contract_agreement.toUpperCase()}
              </h4>
              <table className="contract-table">
                <tr>
                  <td className="contract-td">
                    <p>{this.props.labels.contract_number}</p>
                  </td>
                  <td className="contract-td contract-min-width">
                    <p>
                      {lang === "fr" || lang === "de"
                        ? this.props.formInformation.contractNumber
                        : ""}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td className="contract-td">
                    <p>{this.props.labels.dealer_ref_nr}</p>
                  </td>
                  <td className="contract-td contract-min-width">
                    <p>{this.props.customerInformation.customerNumber}</p>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div className="contract-parties">
            <table className="contract-table">
              <tr className="contract-table-header">
                <th colSpan="4">{this.props.labels.parties.toUpperCase()}</th>
              </tr>
              <tr>
                <td colSpan="2">{this.props.labels.lessor}</td>
                <td colSpan="2">{this.props.labels.lessee}</td>
              </tr>
              <tr>
                <td colSpan="2" className="contract-td contract-half-space">
                  <p className="contract-helper-text">
                    {this.props.params.lang.toLowerCase() === "de"
                      ? this.props.labels.label_dealer_name
                      : this.props.labels.label_customer_name}
                  </p>
                  <p>{this.props.labels.hcs_name}</p>
                </td>
                <td
                  colSpan="2"
                  className="contract-td contract-half-space contract-border-thick"
                >
                  <p className="contract-helper-text">
                    {this.props.params.lang.toLowerCase() === "de"
                      ? this.props.labels.label_customer_name_contract
                      : this.props.labels.label_customer_name}
                  </p>
                  <p>
                    {this.props.customerInformation.customerFirstName +
                      " " +
                      this.props.customerInformation.customerLastName}
                  </p>
                </td>
              </tr>
              <tr>
                <td colSpan="1" className="contract-td contract-quater-space">
                  <p className="contract-helper-text">
                    {this.props.labels.org_number}
                  </p>
                  <p>{this.props.labels.hcs_org_nr}</p>
                </td>
                <td colSpan="1" className="contract-td contract-quater-space">
                  <p className="contract-helper-text">
                    {this.props.labels.postal_adress}
                  </p>
                  <p>{this.props.labels.hcs_adress}</p>
                </td>
                <td
                  colSpan="1"
                  className="contract-td contract-quater-space contract-border-thick"
                >
                  <p className="contract-helper-text">
                    {this.props.labels.social_security_number}
                  </p>
                  <p>{this.props.customerInformation.socialSecurityNumber}</p>
                </td>
                <td colSpan="1" className="contract-td contract-quater-space">
                  <p className="contract-helper-text">
                    {this.props.params.lang !== "fr"
                      ? this.props.labels.postal_adress
                      : "Adresse personnelle"}
                  </p>
                  <p>
                    {this.props.customerInformation.customerStreet +
                      " " +
                      this.props.customerInformation.customerHouseNumber}
                  </p>
                </td>
              </tr>
              <tr>
                <td colSpan="1" className="contract-td contract-quater-space">
                  <p className="contract-helper-text">
                    {this.props.labels.zip_code}
                  </p>
                  <p>{this.props.labels.hcs_zip}</p>
                </td>
                <td colSpan="1" className="contract-td contract-quater-space">
                  <p className="contract-helper-text">
                    {this.props.labels.label_city}
                  </p>
                  <p>{this.props.labels.hcs_city}</p>
                </td>
                <td
                  colSpan="1"
                  className="contract-td contract-quater-space contract-border-thick"
                >
                  <p className="contract-helper-text">
                    {this.props.labels.zip_code}
                  </p>
                  <p>{this.props.customerInformation.customerZipCode}</p>
                </td>
                <td colSpan="1" className="contract-td contract-quater-space">
                  <p className="contract-helper-text">
                    {this.props.labels.label_city}
                  </p>
                  <p>{this.props.customerInformation.customerCity}</p>
                </td>
              </tr>
              <tr>
                <td colSpan="2" className="contract-td contract-half-space">
                  <p className="contract-helper-text">
                    {this.props.params.lang === "fr"
                      ? "Courrier Electronic (questions générales, en français)"
                      : this.props.params.lang === "de"
                        ? "E-Mail (allgemeine Fragen, auf Deutsch)"
                        : this.props.params.lang === "se"
                          ? "E-post (allmänna frågor)"
                          : this.props.params.lang === "no"
                            ? "E-post (generelle spørsmål, på norsk)"
                            : this.props.params.lang === "dk"
                              ? "E-mail (generelle spørsmål, på dansk)"
                              : ""}
                  </p>
                  <p>
                    <strong>
                      {lang === "fr"
                        ? this.props.customerInformation.dealerEmail
                        : this.props.labels.hcs_lease_email}
                    </strong>
                  </p>
                </td>
                <td
                  colSpan="2"
                  className="contract-td contract-half-space contract-border-thick"
                >
                  <p className="contract-helper-text">
                    {this.props.labels.phone_number}
                  </p>
                  <p>{this.props.customerInformation.customerPhone}</p>
                </td>
              </tr>
              <tr>
                <td colSpan="2" className="contract-td contract-half-space">
                  <p className="contract-helper-text">
                    {this.props.params.lang === "fr" ? (
                      <>
                        Contact HCS (questions sur les factures/paiements, en
                        anglasis)
                      </>
                    ) : this.props.params.lang === "de" ? (
                      <>
                        E-Mail HCS (Fragen zu Rechnungen/Zahlungen, auf
                        Englisch)
                      </>
                    ) : this.props.params.lang === "se" ? (
                      <>E-post HCS (frågor om fakturor/betalningar)</>
                    ) : this.props.params.lang === "no" ? (
                      <>
                        E-post HCS (spørsmål om fakturaer/betalinger, på svensk)
                      </>
                    ) : this.props.params.lang === "dk" ? (
                      <>
                        E-mail HCS (spørgsmål om fakturaer/betalinger, på
                        svensk)
                      </>
                    ) : (
                      ""
                    )}
                  </p>
                  <p>
                    {this.props.params.lang === "fr"
                      ? this.props.labels.hcs_email_support
                      : this.props.labels.hcs_email}
                  </p>
                </td>
                <td
                  colSpan="2"
                  className="contract-td contract-half-space contract-border-thick"
                >
                  <p className="contract-helper-text">
                    {this.props.labels.label_email}
                  </p>
                  <p>{this.props.customerInformation.customerEmail}</p>
                </td>
              </tr>
            </table>
            {this.props.params.lang === "dk" && (
              <>
                <h5 className="contract-small-margin-top">
                  <strong>LEASINGTAGERS LOVBESTEMTE OPSIGELSESDGANG</strong>
                </h5>
                <p className="contract-no-margin-top">
                  Leasingtager er berettiget til at opsige denne Aftale med 1
                  måneds varsel til udgangen af en måned, når der er gået
                  [5]/[11] måneder efter indgåelsen af denne Aftale.
                </p>
              </>
            )}
          </div>
          <div className="margin-top-large">
            <table className="contract-table">
              <tr className="contract-table-header">
                <th colSpan="3">{this.props.labels.contact_dealer}</th>
              </tr>
              <tr>
                <td colSpan="1" className="contract-td contract-third-space">
                  <p className="contract-helper-text">
                    {this.props.labels.label_customer_name}
                  </p>
                  <p>{this.props.customerInformation.dealerName}</p>
                </td>
                <td colSpan="1" className="contract-td contract-third-space">
                  <p className="contract-helper-text">
                    {this.props.labels.phone_number}
                  </p>
                  <p>{this.props.customerInformation.dealerPhone}</p>
                </td>
                <td colSpan="1" className="contract-td contract-third-space">
                  <p className="contract-helper-text">
                    {this.props.labels.label_email}
                  </p>
                  <p>{this.props.customerInformation.dealerEmail}</p>
                </td>
              </tr>
              <tr>
                <td colSpan="1" className="contract-td contract-third-space">
                  <p className="contract-helper-text">
                    {this.props.labels.postal_adress}
                  </p>
                  <p>{this.props.customerInformation.dealerAdress}</p>
                </td>
                <td colSpan="1" className="contract-td contract-third-space">
                  <p className="contract-helper-text">
                    {this.props.labels.zip_code}
                  </p>
                  <p>{this.props.customerInformation.dealerZipCode}</p>
                </td>
                <td colSpan="1" className="contract-td contract-third-space">
                  <p className="contract-helper-text">
                    {this.props.labels.label_city}
                  </p>
                  <p>{this.props.customerInformation.dealerCity}</p>
                </td>
              </tr>
            </table>
          </div>
          <div className="margin-top-large">
            <table className="contract-table">
              <tr className="contract-table-header">
                <th colSpan="4">
                  {this.props.labels.leasing_fee.toUpperCase()}
                </th>
              </tr>
              <tr>
                <td colSpan="2" className="contract-td contract-half-space">
                  <p className="contract-helper-text">
                    {this.props.labels.monthly_fee_currency}{" "}
                    {this.props.labels.inc_vat}
                  </p>
                  <p style={{ fontWeight: "bold" }}>
                    {formatNumber(
                      roundTotalMonthlyFeeByCountry(
                        this.props.params.lang.toLowerCase(),
                        this.props.formInformation.totalMonthlyFee
                      ),
                      this.props.params.lang,
                      this.props.params.formType
                    )}
                  </p>
                </td>
                <td colSpan="2" className="contract-td contract-half-space">
                  <p className="contract-helper-text">
                    {this.props.labels.number_of_months}
                  </p>
                  <p style={{ fontWeight: "bold" }}>
                    {this.props.formInformation.contractLength}
                  </p>
                </td>
              </tr>
            </table>
          </div>
          {this.props.params.lang === "fr" ||
          this.props.params.lang === "de" ? (
            <p
              dangerouslySetInnerHTML={{
                __html: this.props.labels.appendix_info,
              }}
            />
          ) : (
            <p>{this.props.labels.appendix_info}</p>
          )}
          <p>{this.props.labels.signature_info}</p>
          {this.props.params.lang === "fr" && (
            <>
              <p>
                {this.props.labels.contract_info2}{" "}
                <a
                  href="https://privacyportal.husqvarnagroup.com/fr/privacy-notice/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://privacyportal.husqvarnagroup.com/fr/privacy-notice/
                </a>
              </p>
              <p>{this.props.labels.contract_info3}</p>
            </>
          )}
          {this.props.params.lang === "de" && (
            <p>
              Der Mieter ist damit einverstanden, dass der Händler seine
              persönlichen Daten verarbeiten wird, um ihn zum Ablauf der
              Mietzeit mit Blick auf eine Verlängerung der Mietzeit zu
              kontaktieren.
            </p>
          )}
          {this.props.params.lang === "de" && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                margin: "10px 0",
              }}
            >
              <div
                style={{
                  border: "10px solid black",
                  width: "20px",
                  height: "20px",
                  marginLeft: "20px",
                  boxSizing: "border-box",
                }}
              ></div>
              <span>Ja</span>
              <div
                style={{
                  border: "1px solid black",
                  width: "20px",
                  height: "20px",
                  marginLeft: "20px",
                }}
              ></div>
              <span>Nein</span>
            </div>
          )}

          <div className="margin-top-large">
            <table className="contract-table">
              <tr className="contract-table-header">
                <th colSpan="4">
                  {this.props.labels.signatures.toUpperCase()}
                </th>
              </tr>
              <tr>
                <td colSpan="4">{this.props.labels.lessee}</td>
              </tr>
              <tr>
                <td colSpan="4" className="contract-td contract-half-space">
                  <p className="contract-helper-text">
                    {this.props.labels.signature}
                  </p>
                  <p>{emptyLabel}</p>
                </td>
              </tr>
              <tr>
                <td colSpan="4" className="contract-td contract-half-space">
                  <p className="contract-helper-text">
                    {this.props.params.lang.toLowerCase() === "de"
                      ? this.props.labels.label_customer_name_contract
                      : this.props.labels.label_customer_name}
                  </p>
                  <p>{emptyLabel}</p>
                </td>
              </tr>
              <tr>
                <td colSpan="1" className="contract-td contract-quater-space">
                  <p className="contract-helper-text">
                    {this.props.labels.date}
                  </p>
                  <p>{emptyLabel}</p>
                </td>
                <td
                  colSpan="3"
                  className="contract-td contract-three-quater-space"
                >
                  <p className="contract-helper-text">
                    {this.props.labels.label_city}
                  </p>
                  <p>{emptyLabel}</p>
                </td>
              </tr>
            </table>
          </div>
          <div className="page-break"></div>
          {this.generateDynamicPages(lang)}
        </div>
      </div>
    );
  }
}
